"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegisteredAiAssemblyIds = exports.getRegisteredAiAssemblyObjects = exports.unregisterAiAssembly = exports.registerAiAssemblyObjects = void 0;
const registry = new Map();
function isObjectInScene(object) {
    return !!object.parent;
}
function getOrCreateEntry(assemblyId) {
    const existing = registry.get(assemblyId);
    if (existing) {
        return existing;
    }
    const entry = {
        objects: new Set(),
        updatedAt: 0,
    };
    registry.set(assemblyId, entry);
    return entry;
}
function registerAiAssemblyObjects(assemblyId, objects, assembly, updatedAt) {
    if (!assemblyId) {
        return;
    }
    const entry = getOrCreateEntry(assemblyId);
    objects.forEach((object) => entry.objects.add(object));
    if (assembly && updatedAt >= entry.updatedAt) {
        entry.assembly = assembly;
        entry.updatedAt = updatedAt;
    }
}
exports.registerAiAssemblyObjects = registerAiAssemblyObjects;
function unregisterAiAssembly(assemblyId) {
    if (!assemblyId) {
        return;
    }
    registry.delete(assemblyId);
}
exports.unregisterAiAssembly = unregisterAiAssembly;
function getRegisteredAiAssemblyObjects(assemblyId) {
    if (!assemblyId) {
        return [];
    }
    const entry = registry.get(assemblyId);
    if (!entry) {
        return [];
    }
    const objects = [...entry.objects].filter(isObjectInScene);
    if (!objects.length) {
        registry.delete(assemblyId);
        return [];
    }
    entry.objects = new Set(objects);
    return objects;
}
exports.getRegisteredAiAssemblyObjects = getRegisteredAiAssemblyObjects;
function getRegisteredAiAssemblyIds() {
    return [...registry.keys()];
}
exports.getRegisteredAiAssemblyIds = getRegisteredAiAssemblyIds;
